// extracted by mini-css-extract-plugin
export default {"botaoPrincipal":"BotaoPrincipal_botaoPrincipal__Cp9b-","lg":"BotaoPrincipal_lg__IdWCi"};